export const Pages = {
  CurrentHearingsPage: 'CurrentHearingsPage',
  MyHearingsPageWritten: 'MyHearingsPageWritten',
  MyHearingsPageResponded: 'MyHearingsPageResponded',
  MyHearingsPageReviewed: 'MyHearingsPageReviewed',
  MyHearingsPageInvited: 'MyHearingsPageInvited',
  ConcludedHearingsPage: 'ConcludedHearingsPage',
  AdministrationPage: 'AdministrationPage',
};
